import React, { useState } from "react";
import { BrowserView } from "react-device-detect";
import DropdownMenu from "../Dropdown/DropdownMenu";
import EventUserComponent from "../../EventUser/EventUserComponent";
import Link from "next/link";
import SoundMuteToggle from "../../players/SoundMuteToggle";
import { Modal } from "react-bootstrap";
import AgendaIcon from "../Icons/AgendaIcon";
import BackArrowIcon from "../Icons/BackArrowIcon";
import HomeIcon from "../Icons/HomeIcon";

export default function NavigationBrowserView({
  eventData,
  getHomepageHref,
  handleOnBackClick,
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <BrowserView>
      <div className="nav-logo">
        <img className="mb-5" src="/assets/vvenuesLogoWhite.svg" />
      </div>
      <div className="nav-items">
        <ul className="nav_main">
          <button
            className="nav_item nav_main_btn nav_main_btn__back"
            onClick={handleOnBackClick}
            tabindex="0"
          >
            <BackArrowIcon />
          </button>
          <Link
            href={getHomepageHref()}
            as={eventData && eventData.homepageUrl}
          >
            <button className="nav_item nav_main_btn nav_main_btn__home">
              <HomeIcon />
            </button>
          </Link>
          {eventData && eventData.hasAgenda && (
            <button
              className="nav_item nav_main_btn nav_main_btn__agenda"
              onClick={() => setShowModal(true)}
            >
              <AgendaIcon />
            </button>
          )}
          {eventData && eventData.hasEventUserList && <EventUserComponent />}
          {/* <SoundMuteToggle useIconOnly={true} /> */}
          <DropdownMenu />
        </ul>
      </div>

      <Modal
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
        className="break-sizing modal-action-point"
      >
        <div className="modal-custom">
          <div
            onClick={() => setShowModal(false)}
            className="modal-custom__close"
          >
            <div className="modal-custom__close-inner h-100 d-flex justify-content-center align-items-center">
              &#10005;
            </div>
          </div>
          <div>
            {eventData && eventData.agendaContent && (
              <div
                className="modal-actionpoint-container"
                dangerouslySetInnerHTML={{ __html: eventData.agendaContent }}
              />
            )}
          </div>
        </div>
      </Modal>
    </BrowserView>
  );
}
